import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-inter-regular" }

import { ref, onMounted } from 'vue'
import Navbar from './components/Navbar.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const scrollTop = ref(0)
const windowWidth = ref(document.documentElement.offsetWidth)

onMounted(() => {
  window.addEventListener('scroll', () => {
    scrollTop.value = document.documentElement.scrollTop
  })
  window.addEventListener('resize', () => {
    windowWidth.value = document.documentElement.offsetWidth
  })
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Navbar, {
      "scroll-top": scrollTop.value,
      "window-width": windowWidth.value
    }, null, 8, ["scroll-top", "window-width"]),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ], 1024))
      ]),
      _: 1
    })
  ]))
}
}

})